import React from "react";

const AlertIcon = () => {
  return (
    <svg width="40" height="34" viewBox="0 0 40 34" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M18.7071 3.18409C19.2871 2.19813 20.7129 2.19813 21.2929 3.18409L37.7961 31.2395C38.3843 32.2394 37.6633 33.5 36.5032 33.5H3.49683C2.33671 33.5 1.61573 32.2394 2.20393 31.2395L18.7071 3.18409Z" fill="#FCDE4D" stroke="#DCB700"/>
      <ellipse cx="20" cy="27.2007" rx="2.5" ry="1.94286" fill="#232F3E"/>
      <path d="M20 13.6016L20 21.373" stroke="#232F3E" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
};
export default AlertIcon;